import React from "react";

export class FormToastMessage extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.Message === '' || this.props.Message === null || this.props.Message === undefined) {
            return null;
        }
        return (
            <div className="toastMessage">
                {this.props.Message}
            </div>
        )
    }
}
export default FormToastMessage;